// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// dev

export const environment = {
	production: false,
	organizationPrefix: 'TNP',
	organizationUUID: 'b7e313ce-7236-4b77-ba76-a98366e22044',
	accountId: 'tecnopool-preprod',
	appId: 'it.addiction.catalean.tecnopool.test',
    appIdIos: 'it.addiction.catalean.tecnopool.test',
	appIdAndroid: 'it.addiction.catalean.tecnopool.test',
	authenticationUrl: 'https://auth.datalean-nodejs-preprod.catalean.com/',
	configUrl: 'https://configuration.datalean-nodejs-preprod.catalean.com/',
	// authenticationUrl: 'http://localhost:3020/',
	cataleanCacheUrl: 'https://catbnddev.addictionlab.it/v1/',
	medialibraryUrl: 'https://medialibrary.datalean-nodejs-preprod.catalean.com/medialibrary/v2/',
	productsUrl: 'https://core-entities.datalean-nodejs-preprod.catalean.com/product/v2/',
	wishlistUrl: 'https://core-entities.datalean-nodejs-preprod.catalean.com/wishlist/',
	usersUrl: 'https://user.datalean-nodejs-preprod.catalean.com/user/application/',
	userStructureUrl: 'https://structure.datalean-nodejs-preprod.catalean.com/applicationUserStructure/',
	structuresUrl: 'https://structure.datalean-nodejs-preprod.catalean.com/structure/v2/',
	organizationUrl: 'https://organization.datalean-nodejs-preprod.catalean.com/organization/',
	shareLinkUrl: 'https://translator.datalean-nodejs-preprod.catalean.com/share/',
	shareLinkParseUrl: 'https://translator.datalean-nodejs-preprod.catalean.com/share/parse',
	templateUrl: 'https://translator.datalean-nodejs-preprod.catalean.com/template/',
	applicationGroupUrl: 'https://user.datalean-nodejs-preprod.catalean.com/user/application/groups/',
	defaultLocale: 'en-US',
	version: '1.0.0',
	availableLocales: ['en-US', 'es-ES', 'fr-FR'],
	uuidParameterType: 'MAP_CONTAINER_UUID',
	// 1: normal logout, 2: overwrite check assets to delete on next login, 3: delete assets on logout
	logoutDataRetentionMode: 1,
	resourceBatchLimit: 10,
	catalean: {
		version: 1,
		uuid: '2a2b5733-8658-4127-89ae-07b05a611743',
	},
  checkDevice: true,
  // Analytics configuration
  analytics: {
    enabled: true,
    debug: true, // Disabled in production
    gtmId: '',
    iubendaSiteId: 46825190,
  },

  defaultLinesFeature: ['def07368-15be-41f5-b72f-86c6a132b4ef'],
  defaultMachinesFeature: ['1e684378-9b92-417e-9a87-6efa493e1675'],
  defaultIndustrySolutionFeature: 'e8048773-5578-44f4-b13d-52030db7c29e'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
